const { getEnvironmentFromUrl } = require('@nuskin/ns-common-lib');

const config = {
  dev: {
    url: 'https://apis.dev.nuskin.com/product/graphql',
    env: 'dev'
  },
  test: {
    url: 'https://apis.test.nuskin.com/product/graphql',
    env: 'test'
  },
  prod: {
    url: 'https://apis.nuskin.com/product/graphql',
    env: 'public'
  }
};

/**
 * Get product-api graphQL base URL based on web URL
 * @returns {string} baseUrl (default: prod env url )
 */
function graphQlUrl () {
  const env = getEnvironmentFromUrl(window.location.host);

  if (!config[env]) {
    return config['prod'].url;
  }

  return config[env].url;
}

module.exports = graphQlUrl;
